export default "__VITE_ASSET__DYiQrvQn__"